var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9944 14.2148H10.7237C10.307 14.2148 9.96814 14.5591 9.96814 14.9824C9.96814 15.4065 10.307 15.7499 10.7237 15.7499H14.9944C15.4111 15.7499 15.75 15.4065 15.75 14.9824C15.75 14.5591 15.4111 14.2148 14.9944 14.2148Z",
    fill: "#034766"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73177 5.17795L11.7787 8.44802C11.8763 8.52622 11.893 8.66973 11.8168 8.7697L7.01906 15.0212C6.71746 15.4074 6.27301 15.6259 5.79681 15.6339L3.17772 15.6662C3.03804 15.6678 2.91581 15.5711 2.88406 15.4324L2.28882 12.8444C2.18564 12.3687 2.28882 11.8769 2.59041 11.498L7.41192 5.21665C7.4897 5.11587 7.63335 5.09813 7.73177 5.17795Z",
    fill: "#034766"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5905 6.49908L12.8103 7.473C12.7317 7.57217 12.5904 7.58829 12.4928 7.50928C11.5444 6.74175 9.11578 4.77213 8.44196 4.22632C8.34355 4.14569 8.33006 4.00219 8.40942 3.90221L9.16182 2.96779C9.84437 2.089 11.0349 2.00838 11.9952 2.7743L13.0984 3.65309C13.5508 4.00783 13.8524 4.47544 13.9556 4.96724C14.0746 5.50822 13.9476 6.03953 13.5905 6.49908Z",
    fill: "#034766"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.42afea18.svg";
export { ForwardRef as ReactComponent };